<section class="bg-white py-4 md:py-8 lg:py-16 min-h-screen">
  <div class="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
    <!-- Loading skeleton when cart items are not yet loaded -->
    <section *ngIf="loadingCart" class="w-full">
      <nz-skeleton class="w-full" [nzActive]="true"></nz-skeleton>
      <nz-skeleton [nzActive]="true"></nz-skeleton>
      <nz-skeleton [nzActive]="true"></nz-skeleton>
    </section>

    <div *ngIf="!loadingCart" class="space-y-6 lg:space-y-8">
      <!-- Progress Steps -->
      <div class="my-4 md:my-6 lg:my-8">
        <div class="hidden md:block">
          <nz-steps [nzCurrent]="1">
            <nz-step nzTitle="Select Event" nzStatus="finish"></nz-step>
            <nz-step
              nzTitle="Review Cart"
              nzStatus="finish"
              nzIcon="shopping-cart"
            ></nz-step>
            <nz-step nzTitle="Pay" nzStatus="wait" nzIcon="dollar"></nz-step>
          </nz-steps>
        </div>
        <div class="md:hidden">
          <nz-steps [nzCurrent]="1" nzDirection="vertical">
            <nz-step nzTitle="Select Event" nzStatus="finish"></nz-step>
            <nz-step
              nzTitle="Review Cart"
              nzStatus="finish"
              nzIcon="shopping-cart"
            ></nz-step>
            <nz-step nzTitle="Pay" nzStatus="wait" nzIcon="dollar"></nz-step>
          </nz-steps>
        </div>
      </div>

      <!-- Main Content Grid -->
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
        <!-- Cart Items Section -->
        <div class="lg:col-span-2">
          <div class="bg-white rounded-lg border border-gray-200 p-4 md:p-6">
            <header class="text-center mb-6">
              <h1
                class="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900"
              >
                Your Cart
              </h1>
            </header>

            <p
              class="my-8 text-center text-gray-600"
              *ngIf="cartItems?.length === 0"
            >
              Cart is empty browse
              <a
                routerLink="/tickets"
                class="text-primary font-semibold hover:underline"
                >store</a
              >
              to add products
            </p>

            <ul
              class="space-y-4 md:space-y-6"
              *ngIf="cartItems && cartItems.length > 0"
            >
              <li
                *ngFor="let item of cartItems; index as i"
                class="border-b border-gray-100 pb-4 md:pb-6 last:border-b-0"
              >
                <div
                  class="flex flex-col sm:flex-row items-start sm:items-center gap-3 md:gap-4"
                >
                  <img
                    nz-image
                    [nzSrc]="getItemImage(item)"
                    nzFallback="assets/ticket.png"
                    [alt]="item.productName"
                    class="h-16 w-16 md:h-20 md:w-20 rounded-lg object-cover bg-gray-100 flex-shrink-0"
                  />

                  <div class="flex-1 min-w-0">
                    <h3 class="text-sm md:text-base text-gray-900 font-medium">
                      <span class="font-bold">Ticket Order # {{ i + 1 }}:</span>
                      <span class="block sm:inline mt-1 sm:mt-0">{{
                        item.productName
                      }}</span>
                    </h3>

                    <dl class="mt-2">
                      <div>
                        <dt class="inline font-bold text-lg text-gray-900">
                          {{ item.amount | currency }}
                        </dt>
                      </div>
                    </dl>
                  </div>

                  <div
                    class="flex items-center gap-3 w-full sm:w-auto justify-between sm:justify-end"
                  >
                    <div class="flex items-center gap-2">
                      <label [for]="'qty-' + item.uid" class="sr-only">Quantity</label>
                      <input
                        type="number"
                        name="quantity"
                        min="1"
                        [value]="item.quantity"
                        [disabled]="hasSelectedAddOns(item)"
                        #qtyInput
                        (change)="updateQuantity(item, +qtyInput.value)"
                        [id]="'qty-' + item.uid"
                        class="h-8 w-16 rounded border border-gray-200 bg-gray-50 p-0 text-center text-xs text-gray-600 focus:outline-none disabled:cursor-not-allowed disabled:opacity-60"
                      />
                    </div>

                    <button
                      class="text-gray-600 transition hover:text-red-600 p-1"
                      (click)="showConfirmDelete(item.uid)"
                      title="Remove item"
                    >
                      <span class="sr-only">Remove item</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="h-5 w-5"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                        />
                      </svg>
                    </button>
                  </div>
                </div>

                <div class="mt-4 p-3 md:p-4 bg-gray-50 rounded-lg">
                  <h4 class="font-semibold text-gray-800 text-sm md:text-base">
                    <span class="font-bold">Ticket # {{ i + 1 }}</span> Purchase
                    Details:
                  </h4>
                  <ul class="mt-2 space-y-1">
                    <li
                      *ngIf="hasSelectedAddOns(item)"
                      class="text-sm text-gray-700"
                    >
                      <span class="font-medium">Add-ons:</span>
                      {{ addOnsText(item) }}
                    </li>
                    <li *ngIf="seatUidOf(item)" class="text-sm text-gray-800">
                      <span class="font-medium">Seat:</span>
                      {{ seatDescription(item) }}
                    </li>
                    <li
                      *ngFor="let detail of purchaseDetailKeys(item)"
                      class="text-sm text-gray-600"
                    >
                      <span class="font-medium"
                        >{{ formatCamelCase(detail) }}:</span
                      >
                      {{ item.purchaseDetails[detail] }}
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <!-- Order Details Section -->
        <div class="lg:col-span-1">
          <div
            class="bg-white rounded-lg border border-gray-200 p-4 md:p-6 sticky top-4"
          >
            <h2 class="text-lg md:text-xl font-bold text-gray-900 mb-4 md:mb-6">
              Order Details
            </h2>

            <form [formGroup]="checkoutForm" class="space-y-4 md:space-y-6">
              <nz-form-control nzErrorTip="Enter Full Name">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Full Name
                </label>
                <input
                  formControlName="name"
                  nz-input
                  placeholder="Enter your full name"
                  nzSize="large"
                  type="text"
                  class="w-full"
                />
              </nz-form-control>

              <nz-form-control nzErrorTip="Enter a valid email address.">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Email Address
                </label>
                <input
                  formControlName="email"
                  nz-input
                  placeholder="Enter your email"
                  nzSize="large"
                  type="email"
                  class="w-full"
                />
              </nz-form-control>

              <nz-form-control nzErrorTip="Enter a valid mobile number.">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Mobile Number
                </label>
                <ngx-intl-tel-input
                  [cssClass]="'w-full intl-phone-input'"
                  [preferredCountries]="[CountryISO.Zimbabwe]"
                  [selectedCountryISO]="CountryISO.Zimbabwe"
                  [enableAutoCountrySelect]="true"
                  [enablePlaceholder]="false"
                  [searchCountryFlag]="true"
                  [searchCountryField]="[
                    SearchCountryField.Iso2,
                    SearchCountryField.Name
                  ]"
                  [selectFirstCountry]="false"
                  [phoneValidation]="true"
                  [separateDialCode]="false"
                  [numberFormat]="PhoneNumberFormat.National"
                  placeholder="Enter your mobile number"
                  formControlName="contactNumber"
                  class="w-full"
                ></ngx-intl-tel-input>
              </nz-form-control>

              <!-- Delivery — shown only when the cart's event offers it -->
              <div
                *ngIf="deliveryAvailable"
                class="border-t border-gray-200 pt-4 space-y-4"
              >
                <div class="flex items-center justify-between">
                  <label class="text-sm font-medium text-gray-700">
                    Deliver my order
                  </label>
                  <nz-switch formControlName="delivery"></nz-switch>
                </div>

                <ng-container *ngIf="deliveryEnabled">
                  <!-- No eligible locations for the cart currency -->
                  <p
                    *ngIf="deliveryUnavailable && !loadingDeliveryLocations"
                    class="text-sm text-amber-700 bg-amber-50 border border-amber-300 rounded-lg p-3"
                  >
                    Delivery is currently unavailable for this order. You can
                    still check out without delivery.
                  </p>

                  <ng-container *ngIf="!deliveryUnavailable">
                    <nz-form-control nzErrorTip="Select a delivery location.">
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                      >
                        Delivery Location
                      </label>
                      <nz-select
                        formControlName="deliveryLocationUid"
                        nzSize="large"
                        nzPlaceHolder="Select a location"
                        [nzLoading]="loadingDeliveryLocations"
                        (ngModelChange)="onDeliveryLocationChange($event)"
                        class="w-full"
                      >
                        <nz-option
                          *ngFor="let loc of deliveryLocations"
                          [nzValue]="loc.uid"
                          [nzLabel]="
                            loc.name +
                            ' · ' +
                            loc.city +
                            ' · ' +
                            (loc.deliveryAmount | currency: loc.currency)
                          "
                        ></nz-option>
                      </nz-select>
                    </nz-form-control>

                    <div formGroupName="address" class="space-y-3">
                      <nz-form-control nzErrorTip="Enter your street address.">
                        <label
                          class="block text-sm font-medium text-gray-700 mb-2"
                        >
                          Street Address
                        </label>
                        <input
                          formControlName="addressLine1"
                          nz-input
                          nzSize="large"
                          placeholder="Address line 1"
                          class="w-full"
                        />
                      </nz-form-control>
                      <input
                        formControlName="addressLine2"
                        nz-input
                        nzSize="large"
                        placeholder="Address line 2 (optional)"
                        class="w-full"
                      />
                      <div class="grid grid-cols-2 gap-3">
                        <input
                          formControlName="state"
                          nz-input
                          nzSize="large"
                          placeholder="State / Province"
                          class="w-full"
                        />
                        <input
                          formControlName="postalCode"
                          nz-input
                          nzSize="large"
                          placeholder="Postal code"
                          class="w-full"
                        />
                      </div>
                      <input
                        formControlName="country"
                        nz-input
                        nzSize="large"
                        placeholder="Country"
                        class="w-full"
                      />
                      <!-- City is taken from the selected delivery location -->
                      <p
                        *ngIf="selectedDeliveryLocation"
                        class="text-sm text-gray-600"
                      >
                        City:
                        <span class="font-medium">{{
                          selectedDeliveryLocation.city
                        }}</span>
                      </p>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </form>

            <!-- Order Summary -->
            <div
              *ngIf="cartItems.length > 0"
              class="mt-6 border-t border-gray-200 pt-4 space-y-2"
            >
              <div class="flex justify-between text-sm text-gray-600">
                <span>Subtotal</span>
                <span>{{ itemsTotal | currency: cartCurrency }}</span>
              </div>
              <div
                *ngIf="deliveryEnabled && selectedDeliveryLocation"
                class="flex justify-between text-sm text-gray-600"
              >
                <span>Delivery</span>
                <span>{{ deliveryFee | currency: selectedDeliveryLocation.currency }}</span>
              </div>
              <div
                class="flex justify-between text-base font-bold text-gray-900 pt-2 border-t border-gray-100"
              >
                <span>Total</span>
                <span>{{ orderTotal | currency: cartCurrency }}</span>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="mt-6 md:mt-8 space-y-3" *ngIf="cartItems.length > 0">
              <!-- Email NB -->
              <div
                class="flex gap-3 bg-amber-50 border border-amber-300 rounded-lg p-4"
              >
                <span
                  nz-icon
                  nzType="warning"
                  nzTheme="fill"
                  class="text-amber-500 text-xl flex-shrink-0 mt-0.5"
                ></span>
                <p class="text-sm text-amber-800">
                  <span class="font-bold">NB:</span> Your tickets will be sent
                  to your email address after payment. Please ensure your email
                  is correct and your inbox is not full.
                </p>
              </div>
              <button
                [nzLoading]="checkoutLoading"
                nzType="primary"
                (click)="checkout()"
                nz-button
                nzSize="large"
                nzBlock
                class="w-full"
              >
                Proceed to Checkout
              </button>
              <button
                [nzLoading]="loadingClearCart"
                nzDanger
                nzGhost
                nzType="primary"
                nz-button
                nzSize="large"
                (click)="clearCart()"
                nzBlock
                class="w-full"
              >
                Clear Cart
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
